<template>
    <div class="Home container">
        <Btn></Btn>
        <Card>
            <div class="cardWrapper mt-2">
                <div @click="$router.go(-1)" class="kembali backBtn text-blue mb-3"><i class="fas fa-chevron-left"></i> Kembali</div>
                <form action="">
                    <label for="no">Nomor Anggota</label>
                    <input name="no" class="input-outline" type="number">
                    <label for="tgl">Tanggal Lahir</label>
                    <input name="tgl" class="input-outline" type="date" >
                    <button :class="[isMobile()? 'btn-fill blue rounded mt-2' : 'btn-outline blue rounded mt-2']">Cek Keanggotaan</button>
                </form>
                 <button @click="$router.go(-1)" class="btnBackBottom btn-outline blue rounded">Kembali</button>
            </div>
        </Card>
    </div>
</template>

<script>
import Card from '../components/cardCenter.vue'
import Btn from '../components/backBtn.vue'
// import isMobil?e from '../mixins/isMobile'
export default {
  components: {
    Card,
    Btn
  },
  methods: {
    isMobile () {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
   @import '../assets/scss/Layout/home.scss';
</style>
